export const ru = {
    'show-banners': 'Показать'
};
